(() => {
  const headerGroup = document.querySelector('#header-group');
  if (headerGroup?.querySelector('.section-cz-header')) {
    const updateHeaderHeight = () => {
      document.documentElement.style.setProperty('--cz-header-group-height', `${Math.ceil(headerGroup.getBoundingClientRect().height)}px`);
    };
    updateHeaderHeight();
    new ResizeObserver(updateHeaderHeight).observe(headerGroup);
  }

  const drawer = () => document.querySelector('[data-cz-drawer]');
  const menuButtons = () => document.querySelectorAll('[data-cz-menu-open]');
  const desktopHoverQuery = window.matchMedia('(min-width: 921px) and (hover: hover) and (pointer: fine)');
  const desktopMenuCloseDelay = 180;

  const openMenu = () => {
    const node = drawer();
    if (!node) return;
    node.hidden = false;
    document.body.classList.add('cz-menu-open');
    menuButtons().forEach((button) => button.setAttribute('aria-expanded', 'true'));
    requestAnimationFrame(() => node.classList.add('is-open'));
  };

  const closeMenu = () => {
    const node = drawer();
    if (!node || node.hidden) return;
    node.classList.remove('is-open');
    document.body.classList.remove('cz-menu-open');
    menuButtons().forEach((button) => button.setAttribute('aria-expanded', 'false'));
    window.setTimeout(() => { node.hidden = true; }, 230);
  };

  const closeDesktopMenus = (except = null) => {
    document.querySelectorAll('[data-cz-desktop-menu][open]').forEach((details) => {
      if (details !== except) details.removeAttribute('open');
    });
  };

  const setupDesktopMenuHovers = (root = document) => {
    root.querySelectorAll('[data-cz-desktop-menu]').forEach((details) => {
      if (details.dataset.czHoverReady === 'true') return;
      details.dataset.czHoverReady = 'true';
      let closeTimer;

      details.addEventListener('mouseenter', () => {
        if (!desktopHoverQuery.matches) return;
        window.clearTimeout(closeTimer);
        closeDesktopMenus(details);
        details.setAttribute('open', '');
      });

      details.addEventListener('mouseleave', () => {
        if (!desktopHoverQuery.matches) return;
        window.clearTimeout(closeTimer);
        closeTimer = window.setTimeout(() => details.removeAttribute('open'), desktopMenuCloseDelay);
      });
    });
  };

  const setupCategoryMenus = (root = document) => {
    root.querySelectorAll('[data-cz-category-menu]').forEach((menu) => {
      if (menu.dataset.czCategoryReady === 'true') return;
      menu.dataset.czCategoryReady = 'true';
      const tabs = Array.from(menu.querySelectorAll('[data-cz-category-tab]'));
      const panels = Array.from(menu.querySelectorAll('[data-cz-category-panel]'));
      const activate = (tab) => {
        tabs.forEach((item) => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        panels.forEach((panel) => {
          panel.hidden = panel.dataset.czCategoryPanel !== tab.dataset.czCategoryTab;
        });
      };
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('pointerenter', (event) => {
          if (event.pointerType === 'mouse' && desktopHoverQuery.matches && !panels.some((panel) => panel.contains(document.activeElement))) activate(tab);
        });
        tab.addEventListener('keydown', (event) => {
          let next;
          if (event.key === 'ArrowDown') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault();
          activate(tabs[next]);
          tabs[next].focus();
        });
      });
      const accordions = Array.from(menu.querySelectorAll('[data-cz-category-accordion]'));
      accordions.forEach((current) => current.addEventListener('toggle', () => {
        if (current.open) accordions.forEach((other) => { if (other !== current) other.open = false; });
      }));
    });
  };

  setupDesktopMenuHovers();
  setupCategoryMenus();

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cz-menu-open]')) { openMenu(); return; }
    if (event.target.closest('[data-cz-menu-close]')) { closeMenu(); return; }
    if (event.target.closest('.cz-drawer__nav a')) closeMenu();

    const phoneMenuLink = event.target.closest('.cz-phone-menu__nav a');
    if (phoneMenuLink) {
      const phoneMenu = phoneMenuLink.closest('.cz-phone-menu');
      if (phoneMenu) {
        phoneMenu.querySelectorAll('.cz-phone-menu__group[open]').forEach((group) => group.removeAttribute('open'));
        phoneMenu.removeAttribute('open');
      }
    }

    const desktopSummary = event.target.closest('[data-cz-desktop-menu] > summary');
    if (desktopSummary) {
      closeDesktopMenus(desktopSummary.parentElement);
      return;
    }
    if (!event.target.closest('[data-cz-desktop-menu]')) closeDesktopMenus();

    const tab = event.target.closest('[data-cz-product-filter]');
    if (tab) {
      const section = tab.closest('[data-cz-products]');
      if (!section) return;
      const filter = tab.dataset.czProductFilter;
      section.querySelectorAll('[data-cz-product-filter]').forEach((button) => {
        button.classList.toggle('is-active', button === tab);
        button.setAttribute('aria-selected', button === tab ? 'true' : 'false');
      });
      section.querySelectorAll('[data-cz-product-card]').forEach((card) => {
        card.hidden = filter !== 'all' && card.dataset.vendor !== filter;
      });
      return;
    }

    const brandTab = event.target.closest('[data-cz-brand-tab]');
    if (brandTab) {
      const section = brandTab.closest('[data-cz-brands]');
      if (!section) return;
      const target = brandTab.dataset.czBrandTab;
      section.querySelectorAll('[data-cz-brand-tab]').forEach((button) => {
        const active = button.dataset.czBrandTab === target;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      section.querySelectorAll('[data-cz-brand-panel]').forEach((panel) => panel.classList.toggle('is-active', panel.dataset.czBrandPanel === target));
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const desktopMenu = event.target.closest('[data-cz-desktop-menu]');
      if (desktopMenu) desktopMenu.querySelector('summary').focus();
      const phoneMenu = document.querySelector('.cz-phone-menu[open]');
      if (phoneMenu) {
        phoneMenu.open = false;
        phoneMenu.querySelector('summary').focus();
      }
      closeDesktopMenus();
      closeMenu();
    }
  });

  document.addEventListener('shopify:section:load', (event) => {
    closeDesktopMenus();
    closeMenu();
    setupDesktopMenuHovers(event.target);
    setupCategoryMenus(event.target);
  });
})();
